export const API_BASE_URL: string = 'https://basvuru2.pananet.com.tr/api/v1';
//export const API_BASE_URL: string = 'https://basvurutest.pananet.com.tr/api/v1';
//export const API_BASE_URL: string = 'http://localhost:8080/api/v1';
export const SIGNATURE_PEN_COLOR: string = '#076be6';
export const NEW_CONNECTION_COST: number = 850;
